module.exports = __webpack_public_path__ + "img/background.72f6e38c.png";